import { jsx as _jsx } from "react/jsx-runtime";
export function ResponsiveGrid({ children, className = "", columns = { xs: 1, sm: 2, md: 3, lg: 4 }, gap = "md", }) {
    const gapClasses = {
        sm: "gap-2",
        md: "gap-4",
        lg: "gap-6",
    };
    const gridClasses = [
        columns.xs && `grid-cols-${columns.xs}`,
        columns.sm && `sm:grid-cols-${columns.sm}`,
        columns.md && `md:grid-cols-${columns.md}`,
        columns.lg && `lg:grid-cols-${columns.lg}`,
        columns.xl && `xl:grid-cols-${columns.xl}`,
    ]
        .filter(Boolean)
        .join(" ");
    return _jsx("div", { className: `grid ${gridClasses} ${gapClasses[gap]} ${className}`, children: children });
}
export function Stack({ children, className = "", direction = "column", spacing = "md", align = "stretch", justify = "start", wrap = false, }) {
    const spacingClasses = {
        xs: direction === "row" ? "space-x-1" : "space-y-1",
        sm: direction === "row" ? "space-x-2" : "space-y-2",
        md: direction === "row" ? "space-x-4" : "space-y-4",
        lg: direction === "row" ? "space-x-6" : "space-y-6",
        xl: direction === "row" ? "space-x-8" : "space-y-8",
    };
    const alignClasses = {
        start: "items-start",
        center: "items-center",
        end: "items-end",
        stretch: "items-stretch",
    };
    const justifyClasses = {
        start: "justify-start",
        center: "justify-center",
        end: "justify-end",
        between: "justify-between",
        around: "justify-around",
        evenly: "justify-evenly",
    };
    const directionClass = direction === "row" ? "flex-row" : "flex-col";
    const wrapClass = wrap ? "flex-wrap" : "";
    return (_jsx("div", { className: `flex ${directionClass} ${alignClasses[align]} ${justifyClasses[justify]} ${spacingClasses[spacing]} ${wrapClass} ${className}`, children: children }));
}
export function Flex({ children, className = "", direction = "row", wrap = "nowrap", align = "stretch", justify = "start", gap = "md", }) {
    const directionClasses = {
        row: "flex-row",
        column: "flex-col",
        "row-reverse": "flex-row-reverse",
        "column-reverse": "flex-col-reverse",
    };
    const wrapClasses = {
        nowrap: "flex-nowrap",
        wrap: "flex-wrap",
        "wrap-reverse": "flex-wrap-reverse",
    };
    const alignClasses = {
        start: "items-start",
        center: "items-center",
        end: "items-end",
        stretch: "items-stretch",
        baseline: "items-baseline",
    };
    const justifyClasses = {
        start: "justify-start",
        center: "justify-center",
        end: "justify-end",
        between: "justify-between",
        around: "justify-around",
        evenly: "justify-evenly",
    };
    const gapClasses = {
        xs: "gap-1",
        sm: "gap-2",
        md: "gap-4",
        lg: "gap-6",
        xl: "gap-8",
    };
    return (_jsx("div", { className: `flex ${directionClasses[direction]} ${wrapClasses[wrap]} ${alignClasses[align]} ${justifyClasses[justify]} ${gapClasses[gap]} ${className}`, children: children }));
}
export function Box({ children, className = "", padding = "md", margin = "none", background = "transparent", border = false, rounded = false, shadow = false, }) {
    const paddingClasses = {
        none: "",
        xs: "p-1",
        sm: "p-2",
        md: "p-4",
        lg: "p-6",
        xl: "p-8",
    };
    const marginClasses = {
        none: "",
        xs: "m-1",
        sm: "m-2",
        md: "m-4",
        lg: "m-6",
        xl: "m-8",
    };
    const backgroundClasses = {
        surface: "bg-surface",
        background: "bg-background",
        accent: "bg-accent",
        transparent: "bg-transparent",
    };
    const borderClass = border ? "border border-border" : "";
    const roundedClass = rounded ? "rounded" : "";
    const shadowClass = shadow ? "shadow-card" : "";
    return (_jsx("div", { className: `${paddingClasses[padding]} ${marginClasses[margin]} ${backgroundClasses[background]} ${borderClass} ${roundedClass} ${shadowClass} ${className}`, children: children }));
}
export function Center({ children, className = "", maxWidth = "lg" }) {
    const maxWidthClasses = {
        xs: "max-w-xs",
        sm: "max-w-sm",
        md: "max-w-md",
        lg: "max-w-lg",
        xl: "max-w-xl",
        "2xl": "max-w-2xl",
        full: "max-w-full",
    };
    return _jsx("div", { className: `mx-auto ${maxWidthClasses[maxWidth]} ${className}`, children: children });
}
export function Hide({ children, below, above, className = "" }) {
    let hideClasses = "";
    if (below) {
        const belowClasses = {
            sm: "hidden sm:block",
            md: "hidden md:block",
            lg: "hidden lg:block",
            xl: "hidden xl:block",
        };
        hideClasses = belowClasses[below];
    }
    if (above) {
        const aboveClasses = {
            sm: "sm:hidden",
            md: "md:hidden",
            lg: "lg:hidden",
            xl: "xl:hidden",
        };
        hideClasses = aboveClasses[above];
    }
    return _jsx("div", { className: `${hideClasses} ${className}`, children: children });
}
